import { z } from "zod";

export const positionLabelSchema = z.object({
  id: z.number(),
  label: z.string(),
});

export const pathNameSchema = z.object({
  id: z.number(),
  label: z.string(),
  identifier: z.string(),
});

export const shelvingUnitNameSchema = z.object({
  id: z.number(),
  label: z.string(),
  identifier: z.string(),
});
